import {Role} from "src/_generated/typed-document-nodes-common"
import {localStorageItemName} from "src/constants/local-storage-item-name"
import CommonUtils from "src/utils/Common"

/**
 * A role with its access token, as stored in local storage.
 */
type RoleWithToken = Role & {token: string}

/**
 * Reads the selected role from local storage, if any.
 *
 * @returns {RoleWithToken | undefined} The selected role, or undefined if not found or invalid.
 */
const getTenant = (): RoleWithToken | undefined => {
    const raw = CommonUtils.GetLocal(localStorageItemName.selectedRole)

    if (!raw) {
        return undefined
    }

    try {
        return JSON.parse(raw)
    } catch {
        return undefined
    }
}

/**
 * Reads the tenant ID from the selected role in local storage, if any.
 *
 * @returns {string | undefined} The tenant ID, or undefined if not found or invalid.
 */
const getTenantId = (): string | undefined => {
    return getTenant()?.tenantId
}

/**
 * Reads the tenant name from the selected role in local storage, if any.
 *
 * @returns {string | undefined} The tenant name, or undefined if not found or invalid.
 */
const getTenantName = (): string | undefined => {
    return getTenant()?.tenantName
}

export {getTenantId, getTenantName}
